import { render } from "./tag_pills.vue?vue&type=template&id=54838e58"
import script from "./tag_pills.vue?vue&type=script&lang=js"
export * from "./tag_pills.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__